<script>
    export default {
        mounted: function(){
            var orderProducts = this;

            Event.$on("productQuantityChanged", function(product){
                Event.$emit('productsQuantitiesChanged', orderProducts.$refs, product);
                orderProducts.notifyProductOutOfStock(product)
            });
        },
        methods: {
            notifyProductOutOfStock(orderProduct) {
                let totalQuantitiesOrdered = orderProduct.quantityA1 ? Number(orderProduct.quantityA1) : 0;
                totalQuantitiesOrdered += orderProduct.quantityA2 ? Number(orderProduct.quantityA2) : 0;
                totalQuantitiesOrdered += orderProduct.quantityB1 ? Number(orderProduct.quantityB1) : 0;
                totalQuantitiesOrdered += orderProduct.quantityCg ? Number(orderProduct.quantityCg) : 0;
                totalQuantitiesOrdered += orderProduct.quantityOm ? Number(orderProduct.quantityOm) : 0;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/orders/orderProducts.vue